<template>
  <div class="col-lg-12">
    <div class="row">
      <div class="col my-1" v-if="!defaultProvince">
        <m-province-picker1 v-model="province"/>
      </div>
      <div class="col my-1" v-if="!defaultCity">
        <m-city-picker1 v-model="city" :province="province"/>
      </div>
    </div>
  </div>
</template>

<script>
import mCityPicker1 from "../../City/CityPicker/CityPicker1";
import mProvincePicker1 from "../../Province/Picker/ProvincePicker1";

export default {
  name: "LocationManager1",
  components: {mCityPicker1, mProvincePicker1},
  data() {
    return {
      province: '',
      city: '',
    }
  },
  computed: {
    defaultCity() {
      return this.findAttributeOnSiteInfo('default_city').length > 0
    },
    defaultProvince() {
      return this.findAttributeOnSiteInfo('default_province').length > 0
    }
  },
  async mounted() {
    if (this.defaultProvince) {
      const province = await this.findAttributeOnSiteInfo('default_province')[0];
      this.province = await province.id
    }
    if (this.defaultCity) {
      const site_info_city = await this.findAttributeOnSiteInfo('default_city')[0];
      this.province = await site_info_city.province_id
      this.city = await site_info_city.id
    }
  },
  watch: {
    province: {
      handler: async function (newValue, oldValue) {
        if (newValue != null) {
          await this.$emit('update:province', this.province)
        }
      },
      deep: true
    },
    city: {
      handler: async function (newValue, oldValue) {
        if (newValue != '') {
          await this.$emit('update:city', this.city)
        }
      },
      deep: true
    },
  }
}
</script>

<style scoped>

</style>